import BuyTrial from './buy-trial';
import { flowTypes } from '../../constant';

export default {
  [flowTypes.buyTrial]: BuyTrial,
  [flowTypes.basic2trial]: BuyTrial,
};
